import { TITULOS_ACTIONS, TITULOS_FIELDS_CONFIG, TITULOS_PAGINATE_OPTIONS } from '../../../constants/titulos.constants';
import { Component, inject, Injectable, OnInit } from '@angular/core';
import { Button } from '../../../shared/components/button/button.component';
import { RouterModule } from '@angular/router';
import { Titledescription } from '../../../shared/components/titledescription/titledescription.component';
import { Table } from '../../../shared/components/table/table.component';
import { BaseList } from '../../../shared/baseList.component';
import { TituloService } from '../../../core/titulo.service';
import { TITULOS_COLUMN_NAMES } from '../../../constants/titulos.constants';
import { MatCardModule } from '@angular/material/card';
import { CardComponent } from '../../../shared/components/card/card.component';
import { MatDividerModule } from '@angular/material/divider';
import { TituloInterface } from '../../../models/titulo.model';
import { NivelService } from '../../../core/nivel.service';
@Injectable({
  providedIn: 'any'
})
@Component({
  selector: 'app-titulos',
  imports: [Table, Button, RouterModule, Titledescription,MatCardModule,CardComponent,MatDividerModule],
  templateUrl: './titulos-list.html',
  styleUrl: './titulos-list.scss'
})
export class Titulos extends BaseList<TituloInterface>{
  apiService =  inject(TituloService);
  paginateOptions = TITULOS_PAGINATE_OPTIONS;
  columnNames = TITULOS_COLUMN_NAMES;
  fields = TITULOS_FIELDS_CONFIG;
  actions = TITULOS_ACTIONS;
  entityKey = 'titulos';
  dataSelectNiveles: any[] = [];
  nivelService = inject(NivelService);
  override ngOnInit(): void {
    super.ngOnInit();
    this.getNiveles();
  }
  getNiveles() {
    this.nivelService.getAllForSelect().subscribe((data) => {
      this.dataSelectNiveles = data
    });
  }

}


